{
  "$id": "site-adaptive-json-schema-meta-schema.json",
  "type": "object",
  "description": "JSON schema describing the expected attributes of an Adaptive site schema.",
  "properties": {
    "$schema": {
      "type": "string",
      "enum": [
        "http://json-schema.org/draft-07/schema#"
      ]
    },
    "type": {
      "type": "string",
      "enum": [
        "object"
      ]
    },
    "properties": {
      "type": "object",
      "properties": {
        "unsigned": {
          "type": "object",
          "description": "Unsigned claims of the site visitor.",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "object"
              ]
            },
            "description": {
              "type": "string",
              "enum": [
                "Unsigned claims of the site visitor."
              ]
            },
            "properties": {
              "type": "object",
              "additionalProperties": {
                "$ref": "#/definitions/SiteAdaptiveJSONSchemaClaimsProperties"
              }
            },
            "additionalProperties": {
              "type": "boolean",
              "enum": [
                false
              ]
            }
          },
          "required": [
            "type",
            "description",
            "properties",
            "additionalProperties"
          ]
        }
      },
      "additionalProperties": {
        "$ref": "#/definitions/SiteAdaptiveJSONSchemaClaimsProperties"
      }
    },
    "additionalProperties": {
      "type": "boolean",
      "enum": [
        false
      ]
    }
  },
  "required": [
    "type",
    "properties",
    "additionalProperties"
  ],
  "additionalProperties": false,
  "definitions": {
    "SiteAdaptiveDeterministicJSONSchemaPrimitives": {
      "oneOf": [
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "boolean"
              ]
            },
            "description": {
              "type": "string"
            }
          },
          "required": [
            "type",
            "description"
          ],
          "additionalProperties": false
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "string"
              ]
            },
            "enum": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "description": {
              "type": "string"
            }
          },
          "required": [
            "type",
            "enum",
            "description"
          ],
          "additionalProperties": false
        }
      ]
    },
    "SiteAdaptiveJSONSchemaPrimitives": {
      "oneOf": [
        {
          "$ref": "#/definitions/SiteAdaptiveDeterministicJSONSchemaPrimitives"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "string"
              ]
            },
            "description": {
              "type": "string"
            }
          },
          "required": [
            "type",
            "description"
          ],
          "additionalProperties": false
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "number"
              ]
            },
            "description": {
              "type": "string"
            }
          },
          "required": [
            "type",
            "description"
          ],
          "additionalProperties": false
        }
      ]
    },
    "SiteAdaptiveJSONSchemaClaimsProperties": {
      "oneOf": [
        {
          "$ref": "#/definitions/SiteAdaptiveJSONSchemaPrimitives"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "array"
              ]
            },
            "description": {
              "type": "string"
            },
            "items": {
              "$ref": "#/definitions/SiteAdaptiveJSONSchemaPrimitives"
            }
          },
          "required": [
            "type",
            "description",
            "items"
          ],
          "additionalProperties": false
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "object"
              ]
            },
            "description": {
              "type": "string"
            },
            "properties": {
              "type": "object",
              "additionalProperties": {
                "$ref": "#/definitions/SiteAdaptiveJSONSchemaClaimsProperties"
              }
            },
            "additionalProperties": {
              "type": "boolean",
              "enum": [
                false
              ]
            }
          },
          "required": [
            "type",
            "description",
            "properties",
            "additionalProperties"
          ],
          "additionalProperties": false
        }
      ]
    }
  }
}